// @flow
import styled, { type StyledComponent } from 'styled-components'

const VerticallyCentralizedItems: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export default VerticallyCentralizedItems
